var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotEnjoyLifeWithDogV4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M5.83333 8.33333C6.1625 7.92917 6.6125 7.7 7.08333 7.7C7.55417 7.7 7.99167 7.92917 8.33333 8.33333",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M11.6667 8.33333C11.9958 7.92917 12.4458 7.7 12.9167 7.7C13.3875 7.7 13.825 7.92917 14.1667 8.33333",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M15.3033 4.6967C18.2323 7.62563 18.2323 12.3744 15.3033 15.3033C12.3744 18.2322 7.62567 18.2322 4.69675 15.3033C1.76782 12.3743 1.76782 7.62562 4.69675 4.6967C7.62568 1.76777 12.3744 1.76777 15.3033 4.6967",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M12.9167 12.24C12.9167 12.24 11.8225 13.3333 10 13.3333C8.17667 13.3333 7.08333 12.24 7.08333 12.24",
    stroke: "var(--stroke-0, #7A7670)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotEnjoyLifeWithDogV4);
export default __webpack_public_path__ + "static/media/notEnjoyLifeWithDogV4.09d44b5d3c11d78caf7c7c6a52a35843.svg";
export { ForwardRef as ReactComponent };